import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=7b080a0f&scoped=true"
import script from "./TaskCreate.vue?vue&type=script&lang=js"
export * from "./TaskCreate.vue?vue&type=script&lang=js"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=7b080a0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b080a0f",
  null
  
)

export default component.exports